import { Component, signal } from '@angular/core';
import { PeakEventFormComponent } from "@app/components/forms/peak-event/form.component";
import { PeakEventHelperService } from '@app/services/helpers/peak-event-helper.service';
import { Router, RouterModule } from '@angular/router';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { PeakEventCreate } from '@app/models/peak-event.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { HeadMetaComponent } from '@app/components/ui.component';
import { ToastService } from '@app/services/toast.service';

@Component({
    selector: 'app-peak-event-create',
    templateUrl: './create.page.html',
    styleUrl: './create.page.scss',
    imports: [
        HeadMetaComponent,
        PeakEventFormComponent,
        RouterModule,
        FontAwesomeModule,
    ]
})
export class PeakEventCreatePage {
  public title = 'New Peak Event';
  formValid = signal(false);
  formValue = signal<PeakEventCreate | null>(null);

  faArrowLeft = faArrowLeft;

  constructor(
    private peakEventService: PeakEventHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    
  }

  create() {
    let val = this.formValue();
    if(val) {
      this.peakEventService.create(val)
        .subscribe({
          next: id => {
            console.log(id)
            if(id) {
              this.router.navigateByUrl('/peak-events/' + id);
            }
          },
          error: (err: AppHttpError) => {
            console.log(err.error)
            this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
          }
        });
    }
  }
}
